/**
 * ErrorCard.tsx
 * ----------------
 * Card displaying an error message.
 */

import * as React from 'react';

/**
 * Component properties
 */

interface ErrorCardProps {
    message: string;
    title?: string;
}

/**
 * Card displaying an error message.
 * @param props Component properties
 * @returns Rendered content
 */
export function ErrorCard (props: ErrorCardProps) {
    const { message, title } = props;

    return (
        <div className="error-card">
            <div className="error-card__title">
                {title !== undefined ? title : 'An error occurred'}
            </div>

            <div className="error-card__body">
                <div className="error-card__subtitle">
                    We could not process your requested change due to an unexpected error. Please check the below message for details.
                </div>

                <div className="error-card__message">
                    {message}
                </div>
            </div>
        </div>
    );
}
